import { jsx as _jsx } from "react/jsx-runtime";
import { css, cx } from '@emotion/css';
import { useDrawerThumbnailAsset } from './DrawerThumbnailAssetProvider';
import { useDrawerData } from '../../DrawerProvider';
import { getNumPages } from '../../utils';
const pageCountStyle = css `
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 4px;
    left: 4px;
    min-width: 29px;
    min-height: 22px;
    padding: 2px 8px;

    background-color: #000000;
    color: #ffffff;
    border-radius: 4px;
`;
export const DrawerThumbnailPageCount = () => {
    const { asset } = useDrawerThumbnailAsset();
    const { pageCountOptions: { isEnable, customStyle }, } = useDrawerData();
    const numOfPages = getNumPages(asset);
    const isMultiPages = getNumPages(asset) > 1;
    if (!isEnable || !isMultiPages) {
        return null;
    }
    return _jsx("div", Object.assign({ className: cx('drawer-thumbnail-button-page-count', pageCountStyle, customStyle) }, { children: numOfPages }));
};
//# sourceMappingURL=DrawerThumbnailPageCount.js.map